import { useTranslation } from 'react-i18next';
import {
  Button,
  Checkbox,
  Dropdown,
  Flex,
  MenuProps,
  TableColumnType,
  Typography,
} from "antd";
import { ChangeEvent, FunctionComponent, KeyboardEvent } from "react";

import { DownOutlined, SearchOutlined, SettingOutlined } from "@ant-design/icons";
import { CheckboxOptionType } from "antd/lib";
import FormInput from "../../../../../../../components/form-input/FormInput";
import "./filter-table.scss";

type FilterTableProps = {
  handleOpen?: () => void;
  searchValue: string;
  handleChangeInput: (e: ChangeEvent<HTMLInputElement>) => void;
  handleSearch: (e: KeyboardEvent<HTMLSpanElement>) => void;
  handleSubmitSearch: () => void;
  handleOpenFilter: () => void;
  checkedList: Array<string>;
  listVisible: Array<string>;
  setCheckedList: (value: string[]) => void;
  dataColumns: TableColumnType<any>[];
};

const FilterTable: FunctionComponent<FilterTableProps> = ({
  handleOpen,
  searchValue,
  handleChangeInput,
  handleSearch,
  handleSubmitSearch,
  handleOpenFilter,
  dataColumns,
  checkedList,
  listVisible,
  setCheckedList,
}) => {
  const { t } = useTranslation();
  const options = dataColumns.map(({ key, title }: any) => ({
    label: title,
    value: key,
    disabled: !listVisible.includes(key)
  }));

  const items: MenuProps["items"] = [
    {
      label: (
        <Checkbox.Group
          options={options as CheckboxOptionType[]}
          value={checkedList}
          onChange={(value) => {
            setCheckedList(value as string[]);
          }}
        />
      ),
      key: "radio",
    },
  ];

  const menuProps = {
    items,
  };

  return (
    <>
      <Flex>
        <div className="heading-filter mr-4">
          <Button className="filter-button" onClick={handleOpenFilter}>
            <Typography.Text>{t("Bộ lọc", "Bộ lọc")}</Typography.Text>
            <DownOutlined />
          </Button>
        </div>

        <div className="">
          <FormInput
            placeholder={t("Nhập tên hoặc mã mô hình", "Nhập tên hoặc mã mô hình")}
            value={searchValue}
            onChange={handleChangeInput}
            onKeyPress={handleSearch}
            afterPrefixIcon={<SearchOutlined onClick={handleSubmitSearch} />}
          />
        </div>
        <div className="heading-setting pl-2">
          <Dropdown
            className="btn btn-outlined btn-setting rounded-md"
            menu={menuProps}
            trigger={["click"]}
          >
            <SettingOutlined />
          </Dropdown>
        </div>
      </Flex>
    </>
  );
};

export default FilterTable;
